import { IconProps } from '@/root/shared-types/ui/ui-types'
import { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const PhoneBlueIcon: FC<IconProps> = ({ width = 15, height = 15, ...rest }) => (
  <Icon type="phone" width={width} height={height} alt="PhoneBlueIcon" ignoreRtl {...rest} />
)
